
console.log('GummiPads theme loaded');

(function(){
  function initProductGallery(root){
    var scope = root || document;
    var galleries = Array.prototype.slice.call(scope.querySelectorAll('[data-product-gallery]'));
    if(!galleries.length && scope.matches && scope.matches('[data-product-gallery]')) galleries = [scope];

    galleries.forEach(function(gallery){
      if(gallery.dataset.gpGalleryReady === 'true') return;
      gallery.dataset.gpGalleryReady = 'true';

      var mainButton = gallery.querySelector('[data-gallery-open]');
      var mainImg = gallery.querySelector('#ProductMainImage');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      var lightbox = gallery.querySelector('[data-lightbox]');
      if(!mainImg || !lightbox) return;

      var lbImg = lightbox.querySelector('[data-lightbox-image]');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      var stage = lightbox.querySelector('[data-lightbox-stage]');
      var current = 0;
      var zoomLevel = 1;

      var images = thumbs.map(function(btn){
        return {
          src: btn.getAttribute('data-src'),
          full: btn.getAttribute('data-full') || btn.getAttribute('data-src'),
          alt: btn.getAttribute('data-alt') || mainImg.getAttribute('alt') || ''
        };
      }).filter(function(img){ return !!img.src; });

      if(!images.length){
        images.push({
          src: mainImg.getAttribute('src'),
          full: mainImg.getAttribute('data-full') || mainImg.getAttribute('src'),
          alt: mainImg.getAttribute('alt') || ''
        });
      }

      function applyZoom(){
        if(!lbImg) return;
        lbImg.style.transform = 'scale(' + zoomLevel + ')';
        lightbox.classList.toggle('is-zoomed', zoomLevel > 1);
      }

      function resetZoom(){
        zoomLevel = 1;
        applyZoom();
        if(stage){ stage.scrollTop = 0; stage.scrollLeft = 0; }
      }

      function setActive(index){
        if(index < 0 || index >= images.length) return;
        current = index;
        mainImg.src = images[index].src;
        mainImg.setAttribute('data-full', images[index].full);
        mainImg.alt = images[index].alt;
        if(mainButton) mainButton.setAttribute('data-index', String(index));
        thumbs.forEach(function(btn){ btn.classList.remove('is-active'); });
        if(thumbs[index]) thumbs[index].classList.add('is-active');
      }

      function loadLightboxImage(){
        lbImg.src = images[current].full || images[current].src;
        lbImg.alt = images[current].alt || '';
        resetZoom();
      }

      function openLightbox(index){
        if(typeof index === 'number' && !isNaN(index)) setActive(index);
        loadLightboxImage();
        lightbox.hidden = false;
        lightbox.removeAttribute('hidden');
        lightbox.setAttribute('aria-hidden','false');
        document.body.classList.add('gp-lightbox-open');
        setTimeout(function(){ if(closeBtn) closeBtn.focus({preventScroll:true}); }, 0);
      }

      function closeLightbox(){
        lightbox.hidden = true;
        lightbox.setAttribute('hidden','');
        lightbox.setAttribute('aria-hidden','true');
        document.body.classList.remove('gp-lightbox-open');
        resetZoom();
      }

      function move(delta){
        if(!images.length) return;
        current = (current + delta + images.length) % images.length;
        setActive(current);
        if(!lightbox.hidden) loadLightboxImage();
      }

      thumbs.forEach(function(btn, i){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          setActive(i);
        });
      });

      if(mainButton){
        mainButton.addEventListener('click', function(e){
          e.preventDefault();
          var idx = parseInt(mainButton.getAttribute('data-index') || current, 10);
          openLightbox(idx);
        });
      }

      if(closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if(prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); move(-1); });
      if(nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); move(1); });

      lightbox.addEventListener('click', function(e){
        if(e.target === lightbox) closeLightbox();
      });

      if(stage){
        stage.addEventListener('click', function(e){
          e.stopPropagation();
        });
        stage.addEventListener('wheel', function(e){
          if(lightbox.hidden) return;
          e.preventDefault();
          zoomLevel += (e.deltaY < 0 ? 0.25 : -0.25);
          zoomLevel = Math.max(1, Math.min(3, zoomLevel));
          applyZoom();
        }, {passive:false});
      }

      if(lbImg){
        lbImg.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          zoomLevel = zoomLevel > 1 ? 1 : 2;
          applyZoom();
        });
        lbImg.addEventListener('dblclick', function(e){
          e.preventDefault();
          e.stopPropagation();
          zoomLevel = zoomLevel >= 2.5 ? 1 : 3;
          applyZoom();
        });
      }

      document.addEventListener('keydown', function(e){
        if(lightbox.hidden) return;
        if(e.key === 'Escape') closeLightbox();
        if(e.key === 'ArrowLeft') move(-1);
        if(e.key === 'ArrowRight') move(1);
      });

      var touchStartX = null;
      var touchStartY = null;
      lightbox.addEventListener('touchstart', function(e){
        if(e.touches && e.touches.length === 1){
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }
      }, {passive:true});
      lightbox.addEventListener('touchend', function(e){
        if(touchStartX === null || !(e.changedTouches && e.changedTouches.length)) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if(Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) move(dx > 0 ? -1 : 1);
        touchStartX = null;
        touchStartY = null;
      }, {passive:true});
    });
  }

  function boot(){ initProductGallery(document); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
  document.addEventListener('shopify:section:load', function(e){ initProductGallery(e.target); });
})();
